import { cn } from "@/lib";
import { DiamondPercent } from "lucide-react";

interface Coupon {
    code: string;
    name: string;
    desc: string;
    tnc: string;
    minTransactionAmount: string;
    isActive: boolean;
    maxDiscountAmount: string;
    eventDiscountPercentage: string;
    ticketCodes?: Array<string>;
}

interface TProps {
    // Optional: an event with no coupons omits the field entirely.
    coupons?: Array<Coupon>;
}

const EventDiscount = ({ coupons }: TProps) => {
    const coupon = coupons?.[0];
    return (
        coupon && (
            <div className='py-1 px-2 w-full bg-linear-to-r from-red-600 to-red-400 flex items-center justify-start gap-1 truncate'>
                <DiamondPercent size={16} color="white" />
                <p className={cn('text-[12px] font-semibold tracking-wide text-white truncate')}>
                    {coupon?.eventDiscountPercentage}% off up to ₹{coupon?.maxDiscountAmount} | Use {coupon?.code}
                </p>
            </div>
        )
    );
}

export default EventDiscount;